function initMap() {

	// Custom Styles
	var styles = [
		{
			"featureType": "water",
			"elementType": "all",
			"stylers": [
				{
					"hue": "#7fc8ed"
				},
				{
					"saturation": 55
				},
				{
					"lightness": -6
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "labels",
			"stylers": [
				{
					"hue": "#7fc8ed"
				},
				{
					"saturation": 55
				},
				{
					"lightness": -6
				},
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#83cead"
				},
				{
					"saturation": 1
				},
				{
					"lightness": -15
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#f3f4f4"
				},
				{
					"saturation": -84
				},
				{
					"lightness": 59
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "labels",
			"stylers": [
				{
					"hue": "#ffffff"
				},
				{
					"saturation": -100
				},
				{
					"lightness": 100
				},
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#ffffff"
				},
				{
					"saturation": -100
				},
				{
					"lightness": 100
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels",
			"stylers": [
				{
					"hue": "#bbbbbb"
				},
				{
					"saturation": -100
				},
				{
					"lightness": 26
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#ffcc00"
				},
				{
					"saturation": 100
				},
				{
					"lightness": -35
				},
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry",
			"stylers": [
				{
					"hue": "#ffcc00"
				},
				{
					"saturation": 100
				},
				{
					"lightness": -22
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi.school",
			"elementType": "all",
			"stylers": [
				{
					"hue": "#d7e4e4"
				},
				{
					"saturation": -60
				},
				{
					"lightness": 23
				},
				{
					"visibility": "on"
				}
			]
		}
	]

     const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      // Set zoom level based on device type
      const zoomLevel = isMobile ? 3.4 : 5.2;
  
	// Init Map
	var map = new google.maps.Map(document.getElementById("map"), {
		center: { lat: -30.0173629, lng: 133.0861966 },
		zoom: zoomLevel,
		disableDefaultUI: !0,
		gestureHandling: "cooperative",
		zoomControl: !1,
		mapTypeControl: !1,
		scaleControl: !1,
		streetViewControl: !1,
		rotateControl: !1,
		fullscreenControl: !1,
		styles: styles,
	});

	// Custom Marker
	var icon = {
		url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAyCAYAAAAweqkjAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAJqADAAQAAAABAAAAMgAAAAAyWjMjAAAEr0lEQVRYCcVZXWwUVRQ+Z7cthUJMY1BAedAoRIjQXQiBB2KM+uSDjYmIplgKpVv1QY0JiQkvJCQ+yguBxVoIIYJiQmP00RjDQ5HEXYuRBPxLBOJPbZoaC4Tt9vqdOzudmd2ZnXunu+UkO3PvPd/5zjf33p1zt2VKYqfGHqBbM88j9BliXk2KVqItH7E/iPFR6jraX9GSli/ptY1/a4/FhY2xSqVoqNhDZfU6EW8hQt/IeBbYS5Tmo9SfOY0HQT/ezITli90gP4RZWB9PWQfB/CMe6gDlMiN1UNpVX9ipsQ66XT4BQS/FEVn5mc/R4nQflng6Ki5a2PDlR6lUGsH+eTIqeF7jTD9Qa2s37dnwaxhPuDAtauYiZmp5WFDDxpjHqbVla5i42g2c/+U+Ks180XRR8nTy4JJLclZZUJhSmMGpzxDwRBWueV3JpabOIWdg9YLChoq7AHi2eSqimNVzeBXt8ns9lZ9eX0yT49cg7GE/YMHazDeoc/ka2rH6tuT0Zmxy/K17JkqUyISIhop5wpTa7Q7es7tPgyNsuLAOYtYmEHSBUukXaVH7SuJsm75Ln+hCAi4JWUuOFmrRBHdJyCyM/6M0vY3aN4zap3yBf6J9Hssygs28h8p0GGu01OePbzparrhLuTk+wo9AId+X/ahKlAcQseInKfjWprU4wpgeMg5nPkuDm04b4QUneBuraHFnbJV5bOqIOVaQtnjSWirCLGpiS/uYlbCOjstWeHK0uDM2ZRfcVLTW4gr7xzjVzJ2NxlgBTk9vsMITaS0VYfyTefDsm+ZYQdri+ZpEucIuSsfIlNpJx77rMcIKTvBWxt8K3BU2ahVL+GHxYWEvknqHAD+BjItfcNbGWotDnFetpIp/4YXYackjJekDHJFH6e66CWq7cj+O49totvwOeLZbcgHOk8SZBynHJe+J84WTmIFee7KGRpzEy7tPGN1vJcSmzjQ0RRKyVHquSngzJvvieFEOio8l4Zx3DPPPNJBZ49Zf34yh8CpKsFnnLckhkNy+k4onTNxLlw3hOuEgF/Q6Uck9lzQorOfxf6H6/TnvQjUkp+T2WVCYONo6j0DcDR+muU3JJTmrrFZY3yN38BU9WIVrYhe5dM5gilph4u/sOoHr1SC0Kb2rlVw15OHCdnAZb/T3atCNHpAckivEwoUJcKDrPPba5yExjRkSbskRYdHCJKA99Qb+bNn4Q6RwCncdqy+st+smYvfXiU/q2k8Od2S8V5KiIE6p+hql6qkoiNU48zcoPU/73/Jh8fVnTCKkTLTxPizprTACqzHh0FyBH8mhFPHCJKwvg6N3au4PHqFMRoPg0Fzx4Pil9HPkC2expC/7h4zbzJ9QLmt8zDabMTd7x7IBLO1vbtf4LjESa2F2wqTQplM7sd9KxjkEKzFVRTou3k6YsPV3XcJ+s3iFAKtj4qQE/XZ7zB97rPAxfry84h+qbfMZGsy+WjseP2I/Yy4nr+jHfvve7dbcxSeYhJZcWG4V3muLXsCLLuQ/azIGn8YkU5ZcmOTLrf8d1258GXCGq5jT7q743FHr+/yESbrB7Ch+xOzWFUKqBKd79Zi1lGYF5AvvknwaZP8DAStCUa+mxycAAAAASUVORK5CYII=",
	};

	// Walla Walla
	new google.maps.Marker({
		position: { lat: -35.7634635, lng: 146.8998529 },
		map: map,
		icon: icon
	});

	// Toowoomba
	new google.maps.Marker({
		position: { lat: -27.5454361, lng: 151.9050151 },
		map: map,
		icon: icon
	});

	// Perth
	new google.maps.Marker({
		position: { lat: -31.65363421889325, lng: 116.68625589419938 },
		map: map,
		icon: icon
	});

}
